import { FC, useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'

import { getAxiosSingle } from '../../../pages/api/axios'
import { URL_LIST } from '../../../constants/url'

interface IViewsGet {
  id: string
}

const ViewsGet: FC<IViewsGet> = ({ id }: IViewsGet) => {
  const [views, setViews] = useState('')

  useEffect(() => {
    const getViews = async () => {
      const query = `${URL_LIST.VIEWS_COUNT}?id=${id}`
      const result = await getAxiosSingle(query)
      setViews(result?.views ? String(result.views) : '0')
    }
    getViews()
  }, [])

  return <>{views || <Skeleton width={50} />}</>
}

export default ViewsGet
